import mitt from "mitt";
import {generateUuid} from "@/utils/index"
type Events = {
  "window-change": number;
};
export const windowChangeEmitter = mitt<Events>();

type submitSuccessEvents = {
  "submit-success": string;
};
export const submitSuccessEmitter = mitt<submitSuccessEvents>();

type notifyEvents = {
  "emit-notify": any;
};
export const notifyEmitter = mitt<notifyEvents>();

type changeRouterEvents = {
  "emit-change-router": any;
};
export const changeRouterEmitter = mitt<changeRouterEvents>();
type correspondentUnitEvents = {
  "emit-correspondent-unit": any;
};
export const correspondentUnitEmitter = mitt<correspondentUnitEvents>();

const emitterObj = {};
const generateEmitter = (events) => {
  if (!emitterObj[events]) {
    emitterObj[events] = mitt<{ events: any }>();
  }
  const _emitter = emitterObj[events];
  const onEvent = (cb)=>{
    _emitter.on(events, cb);
  }
  const emitEvent = (obj) => {
    console.log("触发了",events);
    _emitter.emit(events, obj);
  };
  const offEvent = ()=>{
    console.log('解绑')
    _emitter.off(events)
  }
  return {
    onEvent,
    emitEvent,
    offEvent,
  };
};
export default generateEmitter;
//流程变化时以及新增编辑时抛出的事件
export const useFlowEmitter = () => {
  return generateEmitter("form-data-change-approval-flow-change");
};

//初始化keep-alive的组件数据
export const resetPageData = () => {
  return generateEmitter("reset-keepalive-page-data");
};
export const resetListData = () => {};

export const bindEmitter = (key, cb=(e)=>{}) => {
  let { emitEvent, onEvent,offEvent } = generateEmitter(key);
  onEvent((rows) => {
    if (cb) {
      cb(rows);
    }
  });
  return emitEvent;
};
